import { render, staticRenderFns } from "./OrderDraft.vue?vue&type=template&id=4e515ec4&"
import script from "./OrderDraft.vue?vue&type=script&lang=js&"
export * from "./OrderDraft.vue?vue&type=script&lang=js&"
import style0 from "./OrderDraft.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports